import { render, staticRenderFns } from "./LKIconClose.vue?vue&type=template&id=674db9c0&"
import script from "./LKIconClose.vue?vue&type=script&lang=js&"
export * from "./LKIconClose.vue?vue&type=script&lang=js&"
import style0 from "./LKIconClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports